import { useInfiniteQuery } from "@tanstack/react-query";
import queryKey from "../../../../enumerations/queryKey";
import { getFinancialDetailReport, getFinancialReport } from "../service";

export const useGetFinancialReport = ({ params, options }) => {
  Object.keys(params).forEach((key) => {
    if (
      params[key] === null ||
      params[key] === undefined ||
      params[key] === ""
    ) {
      delete params[key];
    }
  });
  const _arrParams = Object.keys(params).map((key) => params[key]);
  return useInfiniteQuery(
    [queryKey.FINANCIAL_REPORT, ..._arrParams],
    ({ pageParam = 1 }) =>
      getFinancialReport({
        params,
        page: pageParam,
      }).then((res) => res.data.data),
    {
      ...options,
    }
  );
};

export const useGetFinancialReportDetail = ({ params, type, options }) => {
  Object.keys(params).forEach((key) => {
    if (
      params[key] === null ||
      params[key] === undefined ||
      params[key] === ""
    ) {
      delete params[key];
    }
  });
  const _arrParams = Object.keys(params).map((key) => params[key]);
  return useInfiniteQuery(
    [queryKey.FINANCIAL_REPORT_DETAIL, type, ..._arrParams],
    ({ pageParam = 1 }) =>
      getFinancialDetailReport({
        params,
        type: type,
        page: pageParam,
      }).then((res) => res.data.data),
    {
      ...options,
    }
  );
};
